import { render, staticRenderFns } from "./ContentBuilderContact.vue?vue&type=template&id=4c61c728"
import script from "./ContentBuilderContact.vue?vue&type=script&lang=js"
export * from "./ContentBuilderContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports